import React from 'react';

import MassDeleteButton from './Delete/MassDeleteButton';
import SetDueDateButton from './SetDueDate/SetDueDateButton';
import MakeKeyDateButton from './KeyDate/MakeKeyDateButton';
import MassUpdateControlsLayout from '../../shared/widgets/MassUpdate/MassUpdateControlsLayout';
import MakePrivateButton from './Private/MakePrivateButton';
import AssignToRolesButton from './AssignToRoles/AssignToRolesButton';
import SetGroupButton from './SetGroup/SetGroupButton';
import { CopyTasksButton, CopyTasksToGlobalPlansButton } from './CopyTasks';
import MakeRoadmapButton from './Roadmap/MakeRoadmapButton';
import { RoadmapCheckboxesToggleWrapper } from 'feature-toggle';

export default function MassUpdateControls() {
  return (
    <MassUpdateControlsLayout>
      <>
        <SetDueDateButton />
        <MassDeleteButton />
        <MakeKeyDateButton />
        <RoadmapCheckboxesToggleWrapper>
          <MakeRoadmapButton />
        </RoadmapCheckboxesToggleWrapper>
        <MakePrivateButton />
        <AssignToRolesButton />
        <SetGroupButton />
        <CopyTasksButton />
      </>
    </MassUpdateControlsLayout>
  );
}

export function AdminMassUpdateControls() {
  return (
    <MassUpdateControlsLayout>
      <>
        <SetDueDateButton />
        <MassDeleteButton />
        <MakeKeyDateButton />
        <RoadmapCheckboxesToggleWrapper>
          <MakeRoadmapButton />
        </RoadmapCheckboxesToggleWrapper>
        <MakePrivateButton />
        <AssignToRolesButton />
        <SetGroupButton />
        <CopyTasksToGlobalPlansButton />
      </>
    </MassUpdateControlsLayout>
  );
}
